// extracted by mini-css-extract-plugin
module.exports = {"faqContent":"faqContent_faqContent__kmmTL","faqHTMLContent":"faqContent_faqHTMLContent__b_l9q"};